import ActionRow from '@shared/components/core/row/ActionRow';
import { getOrganizationIcon } from '@shared/constants/organization/OrganizationValues';
import OrganizationModel from '@shared/models/organizations/OrganizationModel';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import ManagedOrgDetailsDialog from './ManagedOrgDetailsDialog';

export interface IManagedOrgActionRowProps {
    organization: OrganizationModel;
}

export default function ManagedOrgActionRow({ organization }: IManagedOrgActionRowProps) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleNavigate = () => {
        navigate(`/org/${organization.originatedByOrganizationId}/managed/${organization.id}`);
    };

    if (!organization || !organization.originatedByOrganizationId) return null;
    return (
        <>
            <ActionRow
                iconSize={24}
                startIcon={getOrganizationIcon(organization)}
                endIcon="more"
                title={organization.name}
                description={organization.description}
                onClick={() => setOpen(true)}
            />
            <ManagedOrgDetailsDialog open={open} onClose={() => setOpen(false)} org={organization} />
        </>
    );
}
